function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { setCookie, getCookie } from "../util/dom";
import { subscribeToNewsletter } from "../shop/connect";
var Alert = require("../components/alert");
var Newsletter = {};
var geo = {};
var currGeoStats = false;
(function ($) {
  var elClasses = {};
  Newsletter.getClasses = function () {
    return {
      hidden: "d-none",
      isLoading: "is-loading",
      isDisabled: "is-disabled",
      error: "is-invalid"
    };
  };
  Newsletter.updateErrorHtml = function () {
    var formError = this.parentNode.querySelector(".js-form-error");
    if (!formError) {
      formError = this.parentNode.parentNode.querySelector(".js-form-error");
    }
    if (formError && formError.innerText.length > 0) {
      formError.innerText = null;
      this.classList.remove(elClasses.error);
    }
  };
  Newsletter.removeErrors = function (wrapperEl) {
    var inputs = wrapperEl.querySelectorAll("input");
    if (inputs.length === 0) {
      return;
    }
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener("focus", Newsletter.updateErrorHtml);
      inputs[i].addEventListener("click", Newsletter.updateErrorHtml);
    }
  };
  Newsletter.validateEmail = function (email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
  };
  Newsletter.formValidation = function (wrapperEl) {
    var errorMessages = JSON.parse(wrapperEl.getAttribute("data-messages"));
    var email = wrapperEl.querySelector('input[name="esc_email"]');
    var terms = wrapperEl.querySelector('input[name="accept_terms"]');
    var errors = {};

    // Form validation
    if (email.value.length === 0) {
      errors.email = errorMessages && errorMessages.required_email ? errorMessages.required_email : "E-mail field is required";
    } else if (!Newsletter.validateEmail(email.value)) {
      errors.email = errorMessages && errorMessages.invalid_email ? errorMessages.invalid_email : "Email address is invalid";
    }
    if (terms.checked === false) {
      errors.terms = errorMessages && errorMessages.required_terms ? errorMessages.required_terms : "Accept terms is required";
    }

    // Return false if no errors
    if (Object.keys(errors).length === 0) {
      return false;
    }

    // Display error
    for (var key in errors) {
      var errorEl = wrapperEl.querySelector('.js-form-error[data-field="' + key + '"]');
      if (errorEl) {
        errorEl.innerText = errors[key];
      }
      var elToAddClass = key === "email" ? email : terms;
      elToAddClass.classList.add(elClasses.error);
    }
    return true;
  };
  Newsletter.formSubmit = function (form) {
    if (!form) {
      return;
    }
    var hasErrors = Newsletter.formValidation(form);
    var button = form.querySelector('button[type="submit"]');
    if (hasErrors) {
      return setTimeout(function () {
        button.classList.remove(elClasses.isLoading);
      }, 500);
    }

    // Check values
    var $this = $(form);
    var formInputs = $this.serializeArray().reduce(function (acc, input) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, input.name, input.value));
    }, {});
    var item = undefined;
    if (formInputs.hasOwnProperty("item")) {
      item = formInputs.item;
    }
    button.classList.add(elClasses.isLoading);
    form.setAttribute("data-processing", true);
    subscribeToNewsletter(formInputs.esc_email, item, formInputs.esc_gender, formInputs.esc_country, formInputs.esc_language).then(function () {
      // setTimeout( function () {
      // 	button.classList.remove( elClasses.isLoading );
      // 	Newsletter.formSuccess(form);
      // }, 1500 );
      // var targetEl = $( form.dataset.target );
      // if (targetEl && targetEl.attr('id') === 'js-newsletter-modal') {
      // 	var displayTime = targetEl.data('display_time');
      // 	if (form.dataset.success_type === 'alert') {
      // 		displayTime = 0;
      // 	}
      // 	Newsletter.forceCloseModal( targetEl, displayTime );
      // }
    }).catch(function () {
      $this.removeClass("is-success");
      $this.addClass("is-error");
      form.setAttribute("data-processing", false);
    });
  };
  Newsletter.forceCloseModal = function (el, displayTime) {
    setTimeout(function () {
      el.modal("hide");
    }, displayTime * 1000);
  };
  Newsletter.formSuccess = function (form) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var formData = form !== undefined ? form.dataset : {};
    var targetContainer = document.querySelector(formData.target);
    var successType = formData.success_type;
    if (targetContainer && successType === "success-message") {
      Newsletter.displaySuccessMessage(targetContainer, ".js-newsletter-success", ".js-newsletter-content");
    } else if (successType === "alert") {
      var btn = document.getElementById("js-alert-button");
      var btnText = btn ? btn.dataset.text : "";
      var message = formData.alert;
      var status = "success";
      if (data.message != undefined) {
        message = data.message;
      }
      if (data.success != undefined) {
        status = data.success ? "success" : "danger";
      }
      Alert.show(status, message, btnText);
      document.getElementById("js-alert").classList.add("newsletter-alert");
    }
    Newsletter.resetForm(targetContainer, form, successType);
  };
  Newsletter.resetForm = function (targetContainer, form, successType) {
    form.querySelector('input[name="esc_email"]').value = "";
    form.querySelector('input[name="accept_terms"]').checked = false;
    if (successType === "success-message") {
      setTimeout(function () {
        Newsletter.displaySuccessMessage(targetContainer, ".js-newsletter-content", ".js-newsletter-success");
      }, 10000);
    }
  };
  Newsletter.displaySuccessMessage = function (targetContainer, toDisplayClass, toHideClass) {
    if (!targetContainer) {
      return;
    }
    var contentToDisplay = targetContainer.querySelectorAll(toDisplayClass);
    var contentToHide = targetContainer.querySelectorAll(toHideClass);
    if (contentToHide.length > 0) {
      Array.prototype.forEach.call(contentToHide, function (element) {
        element.classList.add(elClasses.hidden);
      });
    }
    if (contentToDisplay.length > 0) {
      Array.prototype.forEach.call(contentToDisplay, function (element) {
        element.classList.remove(elClasses.hidden);
      });
    }
  };
  Newsletter.modal = function (modal) {
    var offsetDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (!modal) {
      return;
    }
    var cookieName = modal.data("cookie");
    var delay = modal.data("delay");
    if (!getCookie(cookieName)) {
      // Show modal
      if (currGeoStats) {
        modal.modal("show");
        setCookie(cookieName, true, 365, "SameSite=None; Secure");
      } else {
        setTimeout(function () {
          modal.modal("show");
          setCookie(cookieName, true, 365, "SameSite=None; Secure");
        }, delay * 1000 - offsetDelay);
      }
    }
  };
  Newsletter.init = function (mainWrapper, modalId) {
    // var btn = document.getElementById( 'js-alert-button' );
    // var btnText = btn ? btn.dataset.text : '';

    // Alert.show( 'success', form.dataset.alert, btnText );

    var container = document.querySelectorAll(mainWrapper);
    if (container.length === 0) {
      return;
    }
    for (var i = 0; i < container.length; i++) {
      // Form submit
      var form = container[i];
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        Newsletter.formSubmit(this);
      });

      // Remove Errors on input change
      Newsletter.removeErrors(form);
    }

    // Newsletter Modal - if cookiebot is disabled
    setTimeout(function () {
      if (typeof window.Cookiebot === 'undefined') {
        var modal = $(modalId);
        if (modal.length) {
          Newsletter.modal(modal, 1000);
        }
      }
    }, 1000);
  };

  // Open newsletter modal after cookiebot has been loaded
  window.addEventListener('CookiebotOnLoad', function () {
    console.log('CookiebotOnLoad');
    var modal = $('#js-newsletter-modal');
    if (modal.length) {
      Newsletter.modal(modal);
    }
  });
  document.addEventListener("DOMContentLoaded", function () {
    elClasses = Newsletter.getClasses();
    if (document.getElementById("geoModal") == undefined || document.getElementById("geoModal") == null) {
      Newsletter.init(".js-newsletter", "#js-newsletter-modal");
    } else {
      if (!document.getElementById("geoModal").dataset.newsmodal) {
        Newsletter.init(".js-newsletter", "#js-newsletter-modal");
      } else {
        geo.init();
      }
    }
  });
  geo.init = function () {
    if (!document.getElementById("closeBtn")) return;
    if (!document.getElementById("js-geo-modal-wrapper")) return;
    if (!document.getElementById("geoModal")) return;
    if (!document.getElementById("js-newsletter-modal")) return;
    document.getElementById("closeBtn").addEventListener("click", function () {
      document.getElementById("geoModal").style.display = "none";
      document.getElementById("js-geo-modal-wrapper").style.display = "none";
      // document.getElementById('js-newsletter-modal').style.display = 'block';
      currGeoStats = true;
      Newsletter.init(".js-newsletter", "#js-newsletter-modal");
    });
    document.getElementById("js-geo-modal-wrapper").addEventListener("click", function () {
      document.getElementById("geoModal").style.display = "none";
      document.getElementById("js-geo-modal-wrapper").style.display = "none";
      // document.getElementById('js-newsletter-modal').style.display = 'block';
      currGeoStats = true;
      Newsletter.init(".js-newsletter", "#js-newsletter-modal");
    });
    document.getElementById("js-geo-modal").addEventListener("click", function () {
      document.getElementById("geoModal").style.display = "none";
      document.getElementById("js-geo-modal-wrapper").style.display = "none";
      // document.getElementById('js-newsletter-modal').style.display = 'block';
      Newsletter.init(".js-newsletter", "#js-newsletter-modal");
    });
  };
})(jQuery);
window.Newsletter = Newsletter;
window.geo = geo;
export default Newsletter;


// WEBPACK FOOTER //
// ./scripts/components/newsletter.js